import { render, staticRenderFns } from "./modalCustomer.vue?vue&type=template&id=1fd3cec6"
import script from "./modalCustomer.vue?vue&type=script&lang=js"
export * from "./modalCustomer.vue?vue&type=script&lang=js"
import style0 from "./modalCustomer.vue?vue&type=style&index=0&id=1fd3cec6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports